<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t("common.wddd") }}</div>
      <!-- 订单表格 -->
      <el-table :data="tableData"
                style="width: 100%;"
                @row-click="handle"
                v-loading="loading"
                :row-style="rowStyle"
                :cell-style="rowClassName"
                :header-cell-style="headerClassName"
      >
        <el-table-column prop="orderCode" :label="$t('common.cds82')" width="180"/>
        <el-table-column prop="productName" :label="$t('common.cds83')">
          <template #default="{row}">
            <template v-if="row.productType&&row.productType<=4">
              {{ $t(`userinfo.vip.service.${row.productType}`) }}
            </template>
            <template v-else-if="row.productType&&row.productType>4">
              {{ $t(`vip.type.${row.productType - 5}`) }}
            </template>
            <template v-else></template>
          </template>
        </el-table-column>
        <el-table-column prop="payTime" :label="$t('common.cds84')" width="180">
          <template #default="{ row }">
            <span style="font-size: 14px">{{ row.payTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderMoney" :label="$t('common.order.amount')" width="180">
          <template #default="{ row }">
            <span style="font-size: 14px">{{ formatMoney(row.orderMoney ?? row.totalMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalMoney" :label="$t('common.amount.realpay')" width="180">
          <template #default="{ row }">
            <span style="font-size: 14px">{{ formatMoney(row.payMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.cz')" width="120">
          <template #default="{ row }">
            <el-button link type="primary" @click.stop="handle(row)">
              {{ $t('common.check') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination
            size="small"
            v-model:current-page="current"
            v-model:page-size="size"
            v-if="total"
            layout="total, prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {useRouter} from "vue-router";
import {getQueryMyOrder} from "@/api/usercenter";
import {ElMessage} from "element-plus";

const router = useRouter()
const tableData = ref([]);
const loading = ref(false);
const current = ref(1);
const size = ref(10);
const total = ref(0);

const formatMoney = (value) => {
  const amount = Number(value)
  if (Number.isNaN(amount)) return value ?? '--'
  return `￥${amount.toFixed(2)}`
}

const formatPayTime = (value) => {
  if (!value) return '--'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
}

const handleCurrentChange = (page) => {
  current.value = page;
  getQueryMyOrderApis();
};


// 获取所有的订单数据
const getQueryMyOrderApis = async () => {
  loading.value = true;
  let res = await getQueryMyOrder(
      {
        pageNo: current.value,
        pageSize: size.value
      }
  )
  if (res.code !== 200) {
    ElMessage.error(res.message)
    return
  }
  const {records} = res.result;
  loading.value = false;
  tableData.value = records;
  current.value = res.result.current;
  total.value = res.result.total;
  size.value = res.result.size;
}

const handle = (row) => {
  const {orderCode} = row
  router.push({path: '/personal/orderDetails', query: {payCode: orderCode}})
}

onMounted(async () => {
  await getQueryMyOrderApis();
})

const rowStyle = () => {
  return {cursor: 'pointer'}
}

const rowClassName = ({columnIndex}) => {
  if (columnIndex === 0) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({columnIndex}) => {
  if (columnIndex === 0) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px', 'white-space': 'nowrap'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px', 'white-space': 'nowrap'}
  }
}
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;


  .right {
    //overflow: auto !important;
    padding-bottom: 40px !important;
    height: auto !important;
    max-width: 1200px !important;
    min-height: 640px !important;
  }
}


:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table th .cell) {
  white-space: nowrap !important;
}
</style>
